import { usePostApi, type WriteApiOptions } from "@shared/api/hooks";
import { AUTH_VALIDATE_RESET_PASSWORD_CODE_SERVICE_NAME } from "../constants";
import type { ValidateResetPasswordCode } from "../types";

export type UseValidateResetPasswordCodeApiOptions = Omit<
  WriteApiOptions<null, ValidateResetPasswordCode>,
  "serviceName" | "idRequired"
>;

/**
 * Step 2 of the reset flow — `POST /v1/{actor}/validate-reset-password-code`.
 *
 * Lets the user find out the code is wrong before typing a new password. The
 * rule is `exists:users,reset_password_code`, so validation *is* the check and
 * a wrong code is a **422** with the message under `reset_password_code` — bind
 * it with `error.fieldError("reset_password_code")`.
 */
export function useValidateResetPasswordCodeApi(
  options?: UseValidateResetPasswordCodeApiOptions
) {
  return usePostApi<null, ValidateResetPasswordCode>({
    serviceName: AUTH_VALIDATE_RESET_PASSWORD_CODE_SERVICE_NAME,
    invalidateKeys: false,
    ...options,
  });
}
